import { render, staticRenderFns } from "./MeshFolderEditFrameDialog.vue?vue&type=template&id=3e738afc"
import script from "./MeshFolderEditFrameDialog.vue?vue&type=script&lang=js"
export * from "./MeshFolderEditFrameDialog.vue?vue&type=script&lang=js"
import style0 from "./MeshFolderEditFrameDialog.vue?vue&type=style&index=0&id=3e738afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports